import { config } from '@app/config';
import { useAuth0 } from '@auth0/auth0-react';

/**
 * Returns true when the given Auth0 name/identity is the Mediainbox admin account.
 */
export function isAdminUserIdentity(name?: string | null): boolean {
  return name === config.adminUserEmail;
}

/**
 * Returns true when the Auth0 session belongs to the Mediainbox admin account.
 * Uses Auth0 identity (not the app/bootstrap user) so it stays true while impersonating.
 */
export function useIsAdminUser(): boolean {
  const { user } = useAuth0();

  return isAdminUserIdentity(user?.name);
}
